export default {
  // Navigation menu
  nav: {
    brand: 'Brand',
    brandStory: 'Brand Story',
    designerStory: 'Designer Story',
    brandCraftsmanship: 'Brand Craftsmanship',
    brandBlockbuster: 'Brand Blockbuster',
    brandHonor: 'Brand Honor & Social Responsibility',
    news: 'News',
    latest: 'Latest',
    media: 'Media Coverage',
    activity: 'Activities',
    trend: 'Trends',
    map: 'Store Map',
    mapDistribution: 'National Store Distribution',
    mapDetail: 'Store Details',
    contact: 'Contact Us',
    contactInfo: 'Contact Information',
    cooperation: 'Cooperation'
  },
  // Language switch
  language: {
    zh: '简体中文',
    en: 'English',
    zhShort: '简',
    enShort: 'En'
  },
  // Footer related
  footer: {
    certification: '2025 | Certified by Frost & Sullivan',
    certificationSilk: '3 consecutive years 【Chinese Silk Women\'s Clothing】 Sales First',
    certificationXiangyunsha: '3 consecutive years 【Chinese Xiangyunsha Women\'s Clothing】 Sales First',
    certificationCertificateNumber: 'Certificate Number: {number}',
    certificationOrigin: 'Source: Frost & Sullivan (Beijing) Consulting Co., Ltd. Shanghai Branch',
    contactAddress: 'Zhejiang, Hangzhou, Shangcheng District, Shuicheng Road, Shan South Print Center 5 Building, Xiangyunsha Silk Hangzhou Headquarters',
    copyright: 'Copyright © 2025 Shine Into 版权所有',
    privacyPolicy: 'Privacy Policy',
    legalStatement: 'Legal Statement',
  },
  // Contact related
  contact: {
    companyEnName: 'Hangzhou Shine into Garments Co., Ltd.',
    companyCName: '杭州响隐服饰有限公司',
    companyAddress: 'Company Address',
    companyAddressContent: 'Shan South Print Center 5 Building, Shine Into Hangzhou Headquarters',
    companyPhone: 'Company Phone',
    cooperation: 'Business Cooperation',
    contactHotline: 'Hotline (Product Inquiry)',
    contactOurTeamEn: 'Contact Our Team',
    contactOurTeamCn: '联系我们的团队',
    contactOurTeamDesc: 'Project cooperation needs, you can contact us or call to negotiate',
    email: 'E-Mall',
    form: {
      name: 'Name',
      company: 'Company',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      submit: 'Submit',
      submitSuccess: 'Submit Success',
      submitFailed: 'Submit Failed',
    }
  },
  // Common
  common: {
    loading: 'Loading...',
    noData: 'No Data',
    loadMore: 'Load More',
    back: 'Back',
    confirm: 'Confirm',
    cancel: 'Cancel',
    submit: 'Submit',
    search: 'Search',
    reset: 'Reset'
  },
  // News related
  news: {
    loadMore: 'Load More',
    loading: 'Loading...',
    noMore: 'No More',
    loadFailed: 'Load Failed, Click to Retry',
    more: 'More',
    currentLocation: 'Current Location',
    viewDetail: 'View Detail',
    original: 'Original',
  },
  // Map related
  map: {
    title: 'Store Map',
    desc: 'Store data until {date}',
    search: 'Search',
    selectArea: 'Please select area',
    emptyText: 'No data, try another area?',
    resultTitle: 'Shine Stores',
  }
}

